
const useCreateAutoProjectConfirmation = (setState) => {
    const handleExitModal = () => {
        setState({openCreateProjectModal: false});
        setState({nameExistError: ''});

    };


    return {handleExitModal};
};

export default useCreateAutoProjectConfirmation;
